import React from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bulkReset } from "../../../../store/bulk-schedule/actions";
import RomboLogo from "../../../../assets/images/logo-map.png";
import i18n from "../../../../i18n";

const StepDone = () => {
  const dispatch = useDispatch();

  return (
    <div className="text-center py-5">
      <i className="mdi mdi-check-circle-outline text-success" style={{ fontSize: 56 }} />
      <h5 className="mt-3">
        {i18n.t("BulkUploadCreated")}
      </h5>
      <p className="text-muted mb-1">
        {i18n.t("BulkUploadProcessingMessage")}
      </p>
      <p className="text-muted">
        {i18n.t("BulkUploadNotificationMessage")}
      </p>
      <div className="d-flex justify-content-center gap-2 mt-4">
        <Link to="/services/bulk-schedule/tasks">
          <Button color="btn btn-request" outline>
            {i18n.t("ViewTaskHistory")}
          </Button>
        </Link>
        <Button
          color="btn btn-go-back"
          outline
          onClick={() => dispatch(bulkReset())}
        >
          {i18n.t("NewUpload")}
        </Button>
      </div>
    </div>
  );
};

export default StepDone;
